import { getAppEnv, getTenantSlug } from "../utils";

export const chiikiConfig = {
  demo: {
    "dev/mock": {
      name: "デモ地域ポイント",
      serviceId: "b43596db-9481-432f-ae7f-d4a89de9af7c",
      iconUrl: "/misc/icons/demo.png",
    },
    "prod/mock": {
      name: "デモ地域ポイント",
      serviceId: "d4336d16-3e2e-42ec-bee5-d5527121e422",
      iconUrl: "/misc/icons/demo.png",
    },
  },
  marumori: {
    "dev/mock": {
      name: "丸森ポイント",
      serviceId: "05602033-97a2-42e9-ba52-95704486936e",
      iconUrl: "/misc/icons/marumori.png",
    },
    "prod/mock": {
      name: "丸森ポイント",
      serviceId: "bb885475-76d6-45f4-b8c0-e237f78949ab",
      iconUrl: "/misc/icons/marumori.png",
    },
  },
  miyagi: {
    "dev/mock": {
      name: "みやぎポイント",
      serviceId: "1895667b-5864-466a-81bb-19fe5ce55f14",
      iconUrl: "/misc/icons/miyagi.png",
    },
    "prod/mock": {
      name: "みやぎポイント",
      serviceId: "e21c1553-1cb9-46ee-a8ad-8f232756e06a",
      iconUrl: "/misc/icons/miyagi.png",
    },
  },
  "shiga-otsu": {
    "dev/mock": {
      name: "ポイント",
      serviceId: "1559763d-7e47-467f-aa7c-b998871905b8",
      iconUrl: "/misc/icons/default.png",
    },
    "prod/mock": {
      name: "ポイント",
      serviceId: "74648e8f-9a25-4ac1-a2a8-38cec6df4c58",
      iconUrl: "/misc/icons/default.png",
    },
  },
  "shiga-otsu-pay": {
    "dev/mock": {
      name: "大津市地域ポイント(支払い用)",
      serviceId: "832d7a44-bcf4-46c5-b321-bc83e73d26f2",
      iconUrl: "/misc/icons/default.png",
    },
    "prod/mock": {
      name: "大津市地域ポイント(支払い用)",
      serviceId: "d0c0f79d-f382-4075-9a2e-0f0b6ef5a303",
      iconUrl: "/misc/icons/default.png",
    },
  },
  "kyoto-kyoto": {
    "dev/mock": {
      name: "京都市ポイント",
      serviceId: "3bacf5f7-4c97-4adb-a338-6dc738087dfe",
      iconUrl: "/misc/icons/default.png",
    },
    "prod/mock": {
      name: "京都市ポイント",
      serviceId: "20c6d673-4457-43ba-80d4-15ab07e8ab04",
      iconUrl: "/misc/icons/default.png",
    },
  },
} as const;

export function getMockTenantByUrl() {
  const env = getAppEnv();
  const slug = getTenantSlug();

  const chiiki = chiikiConfig[slug as keyof typeof chiikiConfig];

  if (!chiiki) {
    throw new Error("chiiki not found");
  }

  const tenant = chiiki[env as keyof typeof chiiki];

  if (!tenant) {
    throw new Error("chiiki env not found");
  }

  return { slug, ...tenant };
}

export function getTenants() {
  const env = getAppEnv();

  const miyagi =
    chiikiConfig["miyagi" as const][
      env as keyof (typeof chiikiConfig)["miyagi"]
    ];

  const marumori =
    chiikiConfig["marumori" as const][
      env as keyof (typeof chiikiConfig)["marumori"]
    ];

  const shigaOtsu =
    chiikiConfig["shiga-otsu" as const][
      env as keyof (typeof chiikiConfig)["shiga-otsu"]
    ];
  const shigaOtsuPay =
    chiikiConfig["shiga-otsu-pay" as const][
      env as keyof (typeof chiikiConfig)["shiga-otsu-pay"]
    ];
  const kyotoKyoto =
    chiikiConfig["kyoto-kyoto" as const][
      env as keyof (typeof chiikiConfig)["kyoto-kyoto"]
    ];

  return [
    { id: "miyagi", slug: "miyagi", ...miyagi },
    { id: "marumori", slug: "marumori", ...marumori },
    { id: "shiga-otsu", slug: "shiga-otsu", ...shigaOtsu },
    { id: "shiga-otsu-pay", slug: "shiga-otsu-pay", ...shigaOtsuPay },
    { id: "kyoto-kyoto", slug: "kyoto-kyoto", ...kyotoKyoto },
  ];
}
